import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, TableCell, TableCellProps } from '@mui/material';

import { MoreVert } from '@altirllc/shared/storybook/stories/icons/MoreVert.stories';

import { IconTooltipButton } from '@/components/iconTooltipButton/IconTooltipButton';

import type { TMember, TMemberListItem } from '@/types/member';

import type { TMemberAction } from './MemberAction';
import { MemberMenu } from './MemberMenu';

type TMemberMenuCellProps = TableCellProps & {
  member: TMemberListItem;
  actions: Record<TMemberAction, (member: TMember) => void>;
};

export const MemberMenuCell = ({ member, actions, ...cellProps }: TMemberMenuCellProps) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const execute = (action: TMemberAction) => {
    actions[action](member);
    setAnchor(null);
  };

  return (
    <TableCell {...cellProps}>
      <IconTooltipButton
        label={t('common.moreActions')}
        onClick={({ currentTarget }) => setAnchor(currentTarget)}
        sx={{ color: 'text.disabled' }}
      >
        <MoreVert />
      </IconTooltipButton>

      <Menu open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)} elevation={5}>
        <MemberMenu status={member.status} execute={execute} permissionLevel={!!member.admin} />
      </Menu>
    </TableCell>
  );
};
